import { Button } from "~/components/ui";
import { Send } from "lucide-react";
import type { FunctionComponent } from "react";

interface ActionCardButtonProps {
  label: string;
  onClick: () => void;
}

export const ActionCardButton: FunctionComponent<ActionCardButtonProps> = ({ label, onClick }) => {
  return (
    <Button
      className="action-card-button"
      icon={<Send size={14} />}
      onClick={onClick}
      data-testid="action-card-trigger"
    >
      {label}
    </Button>
  );
};
